import { Link } from 'react-router-dom';

const ANGLE = 7;

/* Only labelled when it is tipping. At rest the beam is level, which
   says "balanced" on its own, and a caption repeating it is just noise. */
const LABEL = {
  work: 'work-heavy',
  life: 'life-heavy',
};

const PANS = [
  { wing: 'work', to: '/work' },
  { wing: 'life', to: '/life' },
];

/**
 * A beam that tips toward whichever way in you are pointing at.
 *
 * The two pans are the same doors as the cards below, so they behave the
 * same way: real links that lean the beam on hover and on focus. They
 * look like controls, so they had better be controls.
 *
 * The frame around them is decorative and carries no text; only the
 * changing label is hidden from assistive tech, since announcing
 * "work-heavy" on every hover would be noise.
 */
const Balance = ({ lean = 'none', onLean }) => {
  const angle = lean === 'work' ? -ANGLE : lean === 'life' ? ANGLE : 0;
  const set = (value) => () => onLean?.(value);

  return (
    <div className="balance">
      <div className="balance__stage">
        <div className="balance__beam" style={{ transform: `rotate(${angle}deg)` }}>
          <span className="balance__bar" />
          <span className="balance__pivot" />

          {PANS.map(({ wing, to }) => (
            <div
              key={wing}
              className={`balance__pan balance__pan--${wing}`}
              style={{ transform: `rotate(${-angle}deg)` }}
            >
              <span className="balance__wire" />
              <Link
                to={to}
                className="balance__dish"
                onMouseEnter={set(wing)}
                onMouseLeave={set('none')}
                onFocus={set(wing)}
                onBlur={set('none')}
              >
                {wing}
              </Link>
            </div>
          ))}
        </div>

        <span className="balance__post" />
        <span className="balance__base" />
        <span className="balance__label" aria-hidden="true">{LABEL[lean]}</span>
      </div>
    </div>
  );
};

export default Balance;
